const SMALL_SIZE = 100;
const MEDIUM_SIZE = 200;

/**
 * calculate some stats
 * @param {number} size - image size
 * @param {object} format - object for gathering stats
 * @returns {object} calculation
 */
const incrementStats = function incrementStats(size, format) {
  let { small, medium, large, count } = format;

  count++;

  if (size < SMALL_SIZE) {
    small++;
  } else if (size > SMALL_SIZE && size <= MEDIUM_SIZE) {
    medium++;
  } else {
    large++;
  }

  return {
    small,
    medium,
    large,
    count
  };
};

/**
 * calculate page weights for viewport
 * @param {Array} contentSize - page content size obj
 * @returns {object} desktop and mobile weights
 */
export const calculatePageContentWeights = function calc(contentSize) {
  let desktop = {
    small: 0,
    medium: 0,
    large: 0,
    count: 0
  };

  let mobile = {
    small: 0,
    medium: 0,
    large: 0,
    count: 0
  };

  const images = contentSize.reduce((acc, curr) => acc.concat(curr.images), []);

  const { desktopImageSize, mobileImageSize } = images.reduce(
    (sum, imageDetail) => {
      let { desktopImageSize, mobileImageSize } = sum;

      if (imageDetail.context === 'desktop') {
        desktopImageSize += imageDetail.imageSize;
        desktop = incrementStats(imageDetail.imageSize, desktop);
      } else if (imageDetail.context === 'mobile') {
        mobileImageSize += imageDetail.imageSize;
        incrementStats(imageDetail.imageSize, mobile);
        mobile = incrementStats(imageDetail.imageSize, mobile);
      }

      return { desktopImageSize, mobileImageSize };
    },
    { desktopImageSize: 0, mobileImageSize: 0 }
  );

  return {
    desktopImageSize: Math.round(desktopImageSize),
    desktopStats: desktop,
    mobileImageSize: Math.round(mobileImageSize),
    mobileStats: mobile
  };
};
